import { useInfiniteQuery } from '@tanstack/react-query'
import {
  ConversationsQueryParams,
  infiniteChatQueries,
} from '../../../api/chat'
import { ConversationRow } from '../../../generated/api/chat-conversations'

interface UseConversationsReturnType {
  rows: ConversationRow[]
  isLoading: boolean
  isFetchingNextPage: boolean
  fetchNextPage: () => void
}

export const useConversations = (
  params: ConversationsQueryParams
): UseConversationsReturnType => {
  const { data, isLoading, isFetchingNextPage, fetchNextPage } =
    useInfiniteQuery(infiniteChatQueries.conversations(params))

  const rows = data?.pages.flatMap((page) => page.items) ?? []

  return {
    rows,
    isLoading,
    isFetchingNextPage,
    // the default cancels a running refetch and keeps the stale pages
    fetchNextPage: () => fetchNextPage({ cancelRefetch: false }),
  }
}
